export default "__VITE_ASSET__s7Twl5hJ__"